<template>
  <div class="pon-widget" ref="ponWidgetRef">
    <CallPonButton @click="togglePonPopup" :disabled="!hasPaidAccount || isLoadingUserData" />
    <transition name="animation-fade-up">
      <PonModule v-if="isPonPopupOpen" class="pon-widget__dropdown"/>
    </transition>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted} from 'vue';
import CallPonButton from "@/Groups/Pon/private/core/CallPonButton/CallPonButton.vue";
import PonModule from "@/Groups/Pon/private/core/PonModule/PonModule.vue";
import {useUserAuth} from "@/Groups/Pon/private/imports/userStoreData";
//--------------------------------
const isPonPopupOpen = ref(false);
const ponWidgetRef = ref(null);
//--------------------------------
const {hasPaidAccount, isLoadingUserData} = useUserAuth();
const togglePonPopup = () => {
  if (!hasPaidAccount.value || isLoadingUserData.value) return;
  isPonPopupOpen.value = !isPonPopupOpen.value;
};
//--------------------------------
function handleClickOutside(event) {
  if (!ponWidgetRef.value) return;
  if (!ponWidgetRef.value.contains(event.target)) {
    isPonPopupOpen.value = false;
  }
}
//--------------------------------
onMounted(() => {
  document.addEventListener('mousedown', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('mousedown', handleClickOutside);
});
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
